// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1Ri93","title":"ClientReferral_title__3ashE","itemText":"ClientReferral_itemText__23_2g"};